import React, { useEffect, useState } from 'react'
import { formatDateTimeToInput, validateDate } from '../../../_metronic/helpers'
import { ErrorLabel } from '../Label/ErrorLabel'

interface IDateTimeInputProps {
  id?: string
  type?: string
  name?: string
  placeholder?: string
  value?: string | number | undefined
  required?: boolean
  className?: string
  disabled?: boolean
  onChange?: (value: React.ChangeEvent<HTMLInputElement>) => void
  onBlur?: (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void
  min?: Date
  max?: Date
  errorMessage?: string
}

export const DateTimeInput: React.FC<IDateTimeInputProps> = ({
  id,
  placeholder = 'Digite a data inicial',
  value: initialValue = '',
  required = false,
  className = '',
  disabled = false,
  onChange,
  onBlur,
  min,
  max,
  errorMessage,
}) => {
  const [value, setValue] = useState(initialValue)
  const [localError, setLocalError] = useState<string>('')
  const [touched, setTouched] = useState(false)

  useEffect(() => setValue(initialValue), [initialValue])

  const minInput = min ? formatDateTimeToInput(min) : undefined
  const maxInput = max ? formatDateTimeToInput(max) : undefined

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value
    setValue(newValue)
    setLocalError(validateDate(newValue, minInput, maxInput))
    // Repassa sempre, válido ou não: segurar o valor aqui fazia a tela mostrar uma data e o
    // formulário guardar outra.
    onChange?.(e)
  }

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    setTouched(true)
    onBlur?.(e)
  }

  // O erro local só aparece depois que o usuário sai do campo, para não piscar a cada dígito do ano.
  const showError = errorMessage || (touched && localError)

  return (
    <>
      <input
        id={id}
        type='datetime-local'
        data-kt-user-table-filter='nome'
        className={`form-control form-control-solid ${className} ${disabled ? 'text-muted' : ''} ${
          showError ? 'is-invalid' : ''
        }`}
        style={{ backgroundColor: disabled ? 'var(--bs-gray-300)' : 'var(--bs-gray-100)' }}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        required={required}
        disabled={disabled}
        min={minInput}
        max={maxInput}
      />
      {showError && <ErrorLabel>{showError}</ErrorLabel>}
    </>
  )
}
